import moment from "moment";

export const dbDateFormat = (date) => moment(date).format("Y-MM-DD");

export const displayDateFormat = (date, format = "DD MMM Y") =>
  moment(date).format(format);

export const countAdminPackageByItineraryType = (
  reduxPackageData,
  itinerary_type
) =>
  reduxPackageData.filter((pkg) => pkg.itinerary_type === itinerary_type)
    .length || 0;

export const countAccommodationAndExperienceByDay = (
  reduxPackageData,
  sequenceDate,
  itinerary_type
) =>
  reduxPackageData
    .filter((x) => x.itinerary_type === itinerary_type)
    .map(({ child }) =>
      child
        .slice(0, 1)
        .filter(({ start_date, end_date, itinerary_type }) =>
          itinerary_type === 4
            ? dbDateFormat(start_date) <= dbDateFormat(sequenceDate) &&
              dbDateFormat(end_date) > dbDateFormat(sequenceDate)
            : dbDateFormat(start_date) === dbDateFormat(sequenceDate)
        )
    )
    .flat(1).length;

export const calculateDiscountedAmount = (amount, discountPercentage = 0) => {
  if (discountPercentage < 0 || discountPercentage > 100 || amount < 0) {
    throw new Error("Invalid discount percentage or amount");
  }
  return (amount - (amount * discountPercentage) / 100).toFixed(2);
};

export const calculateCustomerPackageBeforeDiscountAmount = (packageData) => {
  return packageData
    .reduce((finalPrice, item) => {
      const selectedChild = item.child.find((child) => child.selected);
      if (!selectedChild) return finalPrice;

      const currentPrice =
        selectedChild.itinerary_type === 4
          ? moment(selectedChild.end_date).diff(
              moment(selectedChild.start_date),
              "days"
            ) * parseFloat(selectedChild.price)
          : parseFloat(selectedChild.price);

      return finalPrice + currentPrice;
    }, 0)
    .toFixed(2);
};

export const calculateAdminPackageBeforeDiscountAmount = (packageData) => {
  return packageData
    .reduce((finalPrice, item) => {
      const selectedChild = item.child[0];
      if (!selectedChild) return finalPrice;

      const currentPrice =
        selectedChild.itinerary_type === 4
          ? moment(selectedChild.end_date).diff(
              moment(selectedChild.start_date),
              "days"
            ) * parseFloat(selectedChild.price)
          : parseFloat(selectedChild.price);

      return finalPrice + currentPrice;
    }, 0)
    .toFixed(2);
};

export const filterSelectedChildDataForItineraryPackage = (customerPackage) =>
  customerPackage
    .map(({ child }) => child.filter(({ selected }) => selected))
    .flat(1);

export const itineraryTypeWithName = {
  4: {
    name: "Accommodations",
  },
  1: {
    name: "Attraction",
  },
  2: {
    name: "Transfers",
  },
  3: {
    name: "Transfers",
  },
};

export const guestCombinationCountFuc = (GuestCombination) =>
  GuestCombination.reduce(
    (count, guest) => ({
      adult: count.adult + parseInt(guest.adultCounter),
      child: count.child + parseInt(guest.childCounter),
      traveler:
        count.adult +
        parseInt(guest.adultCounter) +
        count.child +
        parseInt(guest.childCounter),
      room: count.room + parseInt(guest.roomCounter),
    }),
    { adult: 0, child: 0, room: 0 }
  );

export const prepareDataForCartFromItineraryPackage = (
  packageData,
  givenDiscount,
  guestCombination,
  currentSelectZone
) => {
  const guestCombinationCount = guestCombinationCountFuc(guestCombination);

  return packageData.map((itinerary, index) => {
    if (itinerary.itinerary_type === 4) {
      const {
        property_id,
        property_name,
        start_date,
        end_date,
        check_in,
        check_out,
        address_line_1,
        price,
        description,
        itinerary_type,
        property_source,
        package_id,
        cancellationpolicy,
        firstcancellationdate,
        paylater,
        image,
        roomName,
        room_rateplan,
        // package_start_date,
        // package_end_date,
        // package_name,
        // package_description,
        // package_image,
        // package_guestCombination_sentence,
        // package_night,
      } = itinerary;

      let date1 = new Date(start_date);
      let date2 = new Date(end_date);

      const givenPrice = calculateDiscountedAmount(
        parseFloat(price),
        givenDiscount
      );

      let timeDiff = Math.abs(date1.getTime() - date2.getTime());
      let numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));
      let TotalPrice = givenPrice * numberOfNights;
      let PercentageOfferAm = parseFloat(price - givenPrice) * numberOfNights;
      let TotalAmountAll = PercentageOfferAm + TotalPrice;
      let SinglePrice = givenPrice;

      return {
        package_id,
        tour_id: null,
        dateselected: null,
        tourImage: null,
        number: null,
        ratePlanId: null,
        numberTraveler: null,
        tourName: null,
        tourOption: null,
        tourLocation: null,
        time: null,
        price_type: null,
        tour_operator_id: null,
        profileactivity: itineraryTypeWithName[itinerary_type].name,
        overview: null,
        hotel_id: property_id,
        propertyName: property_name,
        hotelimage: image,
        startDate: start_date,
        endDate: end_date,
        guestCombination: guestCombination,
        property_source: property_source,
        rateplancode: null,
        cartvalue: [
          {
            adultCounter: room_rateplan[0].adult_count,
            childCounter: room_rateplan[0].child_count,
            roomCounter: room_rateplan[0].room_count,
            id: room_rateplan[0].rate_plan_id,
            amount: TotalPrice,
            room_id: room_rateplan[0].property_room_id,
            roomAvail: room_rateplan[0].room_available,
          },
        ],
        hotelData: JSON.stringify({
          defaultZoneval: currentSelectZone,
          startDate: start_date,
          endDate: end_date,
          guestCombination: guestCombination,
          accopage: 1,
          accosize: 20,
        }),
        roomcount: guestCombinationCount.room,
        adultcount: guestCombinationCount.adult,
        childcount: guestCombinationCount.child,
        junifer: null,
        price: TotalPrice,
        percentageAm: PercentageOfferAm,
        percentage: givenDiscount,
        totalAmount: TotalAmountAll,
        taxfeeepercent: 0,
        totalamountincluded: TotalPrice,
        taxamount: 0,
        bookingEjunifer: null,
        checkin: check_in,
        checkout: check_out,
        propertydescription: description ?? "test",
        propertylocation: address_line_1,
        singleamount: SinglePrice,
        typedata: "single",
        roomname: roomName,
        roombooking: [
          {
            room_id: room_rateplan[0].property_room_id,
            roomBooking: 1,
            rateplanId: room_rateplan[0].id,
          },
        ],
        accommodationtype: "hsl",
        OfferName: "",
        cancellationpolicy: cancellationpolicy,
        firstcancellationdate: firstcancellationdate,
        paylater: paylater,
        serviceDate: start_date,
        // package_start_date,
        // package_end_date,
        // package_name,
        // package_description,
        // package_image,
        // package_guestCombination_sentence,
        // package_night,
      };
    } else {
      const {
        package_id,
        experience_id,
        start_date,
        image,
        plan_id,
        experience_adult,
        experience_child,
        experience_group,
        experience_infant,
        experience_youth,
        experience_senior,
        name,
        option_name,
        address,
        experience_time,
        price_typeid,
        price,
        description,
        offer_description,
        itinerary_type,
        tour_operator_id,
        cancellationpolicy,
        firstcancellationdate,
        paylater,
        // package_start_date,
        // package_end_date,
        // package_name,
        // package_description,
        // package_image,
        // package_guestCombination_sentence,
        // package_night,
      } = itinerary;

      const givenPrice = parseFloat(price);
      const extracharges = 0;
      const totaltax = (
        Math.round(extracharges * givenPrice) / 100 || 0
      ).toFixed(2);
      const TotalAmount = (givenPrice + parseFloat(totaltax || 0)).toFixed(2);
      const taxamount = parseFloat(totaltax);
      const offer_Percentage =
        givenDiscount === "" ? 0 : parseFloat(givenDiscount).toFixed(2);
      const Percentage = isNaN(offer_Percentage)
        ? 0
        : parseFloat(offer_Percentage);
      const Selling_Price = calculateDiscountedAmount(TotalAmount, Percentage);
      const PercentageAm = (
        parseFloat(TotalAmount) - parseFloat(Selling_Price)
      ).toFixed(2);

      return {
        package_id,
        tour_id: experience_id,
        dateselected: start_date,
        tourImage: image,
        number: index,
        ratePlanId: plan_id,
        numberTraveler: JSON.stringify([
          {
            adultCounter: experience_adult,
            infantCounter: experience_infant,
            childCounter: experience_child,
            youthCounter: experience_youth,
            seniorCounter: experience_senior,
            groupCounter: experience_group,
          },
        ]),
        tourName: name,
        tourOption: option_name,
        tourLocation: address,
        time: experience_time,
        price_type: price_typeid,
        tour_operator_id: tour_operator_id,
        profileactivity: itineraryTypeWithName[itinerary_type].name,
        overview: description,
        price: Selling_Price,
        percentageAm: PercentageAm,
        percentage: Percentage,
        totalAmount: Selling_Price,
        taxfeeepercent: extracharges,
        totalamountincluded: Selling_Price,
        taxamount: taxamount,
        transfertype: "",
        isChecked: false,
        traveller: guestCombinationCount.traveler,
        availability: null,
        OfferName: offer_description,
        cancellationpolicy: cancellationpolicy,
        firstcancellationdate: firstcancellationdate,
        paylater: paylater,
        serviceDate: start_date,
        cancellationpolicy: cancellationpolicy,
        // package_start_date,
        // package_end_date,
        // package_name,
        // package_description,
        // package_image,
        // package_guestCombination_sentence,
        // package_night,
      };
    }
  });
};

export const generateDateRange = (startDate, days) => {
  const start = new Date(startDate);
  const end = new Date(start);
  end.setDate(end.getDate() + days);

  const dates = [];
  const currentDate = new Date(start);

  while (currentDate <= end) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

export const getDateDifference = (start, end, unit = "days") => {
  if (unit === "days") {
    return moment(end)
      .startOf("day")
      .diff(moment(start).startOf("day"), "days");
  }
  return moment(end).diff(moment(start), unit);
};

export const addDaysToDate = (date, days, keepTime = false) => {
  return keepTime
    ? moment(date).add(days, "days").format("YYYY-MM-DD HH:mm:ss")
    : moment(date).add(days, "days").startOf("day").format("YYYY-MM-DD");
};

export const calculateBalanceAmountExperience = (i, total) => {
  if (i.specialOffer != "no_offer") {
    let result = [];

    i.specialOffer.forEach((l) => {
      // combine or nocombile offers code are same
      const disA =
        l.specialdata.discount_id == 2
          ? l.specialdata.rate_amount
          : total - l.specialdata.rate_amount;
      result.push(+disA);
    });

    const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);
    const $UpliftAmount = (parseInt(i.priceuplift[0]) / 100) * total;
    const UpliftTotal = parseInt(total) + $UpliftAmount;
    const balanceAmount =
      UpliftTotal - (Math.round(Amount * UpliftTotal) / 100).toFixed(2);

    return balanceAmount;
  } else {
    const $UpliftAmount = (parseInt(i.priceuplift[0]) / 100) * total;
    const UpliftTotal = parseInt(total) + $UpliftAmount;
    return UpliftTotal;
  }
};

const currencySign = "€";
const handleNaN = (value, returnValue = 0) =>
  isNaN(value) ||
  value === undefined ||
  value === "undefined" ||
  value === null ||
  value === "null"
    ? returnValue
    : Number(value);

export const constant = {
  amountWithCurrency: (amount, currency = currencySign) =>
    `${currency} ${handleNaN(amount).toFixed(2)}`,
  pickAmount: (amount) => amount.match(/\d+(\.\d+)?/g),
  handleNaN,
  currencySign,
};

export const calculateTotalPrice = (
  x,
  groupCounter,
  adultCounter,
  infantCounter,
  childCounter,
  youthCounter,
  seniorCounter
) => {
  let getAmount = x.price[0].map((item, index) => {
    if (item.group_price > 0) {
      if (
        (item.flexible_id == 0 && groupCounter <= item.group_max) ||
        (item.flexible_id != 0 &&
          groupCounter >= item.group_min &&
          groupCounter <= item.group_max)
      ) {
        return calculateBalanceAmountExperience(x, item.group_price);
      }
    } else {
      if (item.flexible_id == 0) {
        let total =
          constant.handleNaN(item.adult_price) * adultCounter +
          constant.handleNaN(item.infant_price) * infantCounter +
          constant.handleNaN(item.child_price) * childCounter +
          constant.handleNaN(item.youth_price) * youthCounter +
          constant.handleNaN(item.senior_price) * seniorCounter;

        return calculateBalanceAmountExperience(x, total);
      } else {
        if (index == 0) {
          let adultTotal = 0,
            infantTotal = 0,
            childTotal = 0,
            youthTotal = 0,
            seniorTotal = 0;

          if (adultCounter > 0) {
            let adultTo = x.price[0].filter(
              (y) => adultCounter <= y.adult_max && adultCounter >= y.adult_min
            );

            if (adultTo.length > 0) {
              adultTotal =
                constant.handleNaN(adultTo[0].adult_price) * adultCounter;
            }
          }
          if (infantCounter > 0) {
            let infantTo = x.price[0].filter(
              (y) =>
                infantCounter <= y.infant_max && infantCounter >= y.infant_min
            );

            if (infantTo.length > 0) {
              infantTotal =
                constant.handleNaN(infantTo[0].infant_price) * infantCounter;
            }
          }
          if (childCounter > 0) {
            let childTo = x.price[0].filter(
              (y) => childCounter <= y.child_max && childCounter >= y.child_min
            );

            if (childTo.length > 0) {
              childTotal =
                constant.handleNaN(childTo[0].child_price) * childCounter;
            }
          }
          if (youthCounter > 0) {
            let youthTo = x.price[0].filter(
              (y) => youthCounter <= y.youth_max && youthCounter >= y.youth_min
            );

            if (youthTo.length > 0) {
              youthTotal =
                constant.handleNaN(youthTo[0].youth_price) * youthCounter;
            }
          }
          if (seniorCounter > 0) {
            let seniorTo = x.price[0].filter(
              (y) =>
                seniorCounter <= y.senior_max && seniorCounter >= y.senior_min
            );

            if (seniorTo.length > 0) {
              seniorTotal =
                constant.handleNaN(seniorTo[0].senior_price) * seniorCounter;
            }
          }

          let total =
            adultTotal + infantTotal + childTotal + youthTotal + seniorTotal;

          if (total != 0) {
            return calculateBalanceAmountExperience(x, total);
          }
        }
      }
    }
  });

  return getAmount
    .filter((x) => x)
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
};

export const findRoomOptionById = (hotelArray, roomOptionsId) => {
  return hotelArray
    .flatMap((category) =>
      Object.values(category).flatMap((roomType) => roomType.roomOptions)
    )
    .find((option) => option.id === roomOptionsId);
};

// export const findRoomCancellationById = (hotelArray, roomOptionsId) => {
//   return hotelArray.flatMap((item) =>
//     Object.values(item).flatMap((room) =>
//       room.roomCancellation.filter((cancelArray) =>
//         cancelArray.some((cancel) => cancel.rate_plan_id === roomOptionsId)
//       )
//     )
//   );
// };

// export const findRoomFreeCancellationById = (
//   hotelArray,
//   roomOptionsId,
//   startDate
// ) => {
//   const freeRoomCancellation = hotelArray.flatMap((item) =>
//     Object.values(item).flatMap((room) =>
//       room.freeroomCancellation.filter((cancelArray) =>
//         cancelArray.some((cancel) => cancel.rate_plan_id === roomOptionsId)
//       )
//     )
//   );

//   if (freeRoomCancellation.length === 0) {
//     return { date: "", paylater: "" };
//   }

//   let firstcancellationdate = "";
//   let paylater = "";
//   if (freeRoomCancellation.length > 0) {
//     let freeDate = freeRoomCancellation[0].day_before_arrival;
//     let cancellationDate = moment(startDate)
//       .subtract(freeDate, "days")
//       .format("YYYY-MM-D");
//     let NewFreeConstDate = moment(cancellationDate)
//       .subtract(15, "days")
//       .format("YYYY-MM-D");
//     let currentDate = new Date();
//     let NewcurrentDate = moment(currentDate).format("YYYY-MM-D");
//     if (NewFreeConstDate >= NewcurrentDate) {
//       firstcancellationdate = cancellationDate;
//       paylater = 1;
//     } else {
//       firstcancellationdate = cancellationDate;
//     }
//   }

//   return {
//     date: firstcancellationdate,
//     paylater: paylater,
//   };
// };

export const findRoomCancellationById = (
  hotelArray,
  roomOptionsId,
  startDate
) => {
  const matchedRooms = hotelArray.flatMap((item) =>
    Object.values(item).filter((room) =>
      room.roomOptions.some((option) => option.id === roomOptionsId)
    )
  );

  if (matchedRooms.length === 0) {
    return { date: "", paylater: "", roomCancellation: [] };
  }

  const roomCancellation = matchedRooms[0].roomCancellation;

  const firstCancellation = matchedRooms[0].freeroomCancellation[0];

  if (!firstCancellation) {
    return { date: "", paylater: "", roomCancellation };
  }

  let firstcancellationdate = "";
  let paylater = "";
  if (firstCancellation.length > 0) {
    let freeDate = firstCancellation[0].day_before_arrival;
    let cancellationDate = moment(startDate)
      .subtract(freeDate, "days")
      .format("YYYY-MM-D");
    let NewFreeConstDate = moment(cancellationDate)
      .subtract(15, "days")
      .format("YYYY-MM-D");
    let currentDate = new Date();
    let NewcurrentDate = moment(currentDate).format("YYYY-MM-D");
    if (NewFreeConstDate >= NewcurrentDate) {
      firstcancellationdate = cancellationDate;
      paylater = 1;
    } else {
      firstcancellationdate = cancellationDate;
    }
  }

  return {
    date: firstcancellationdate,
    paylater: paylater,
    roomCancellation,
  };
};

export const findFreeCancellationDateAndPayLater = (
  freecancellationpolicy,
  startDate
) => {
  if (freecancellationpolicy.length === 0) {
    return { date: "", paylater: "" };
  }

  let firstcancellationdate = "";
  let paylater = "";
  if (freecancellationpolicy.length > 0) {
    let freeDate = freecancellationpolicy[0]?.day_before_arrival;
    let cancellationDate = moment(startDate)
      .subtract(freeDate, "days")
      .format("YYYY-MM-D");
    let NewFreeConstDate = moment(cancellationDate)
      .subtract(15, "days")
      .format("YYYY-MM-D");
    let currentDate = new Date();
    let NewcurrentDate = moment(currentDate).format("YYYY-MM-D");
    if (NewFreeConstDate >= NewcurrentDate) {
      firstcancellationdate = cancellationDate;
      paylater = 1;
    } else {
      firstcancellationdate = cancellationDate;
    }
  }

  return {
    date: firstcancellationdate,
    paylater: paylater,
  };
};

export const pluralize = (word, count) => {
  if (!word) return "";
  if (count === 1) {
    return makeSingular(word);
  }
  return makePlural(word);
};

export const makeSingular = (word) => {
  const irregularSingulars = {
    children: "child",
    people: "person",
    mice: "mouse",
    teeth: "tooth",
    feet: "foot",
    geese: "goose",
    men: "man",
    women: "woman",
  };

  let words = word.split(" ");
  let lastWord = words.pop();

  if (irregularSingulars[lastWord.toLowerCase()]) {
    words.push(irregularSingulars[lastWord.toLowerCase()]);
  } else if (lastWord.match(/ies$/i)) {
    words.push(lastWord.replace(/ies$/, "y")); // activities → activity
  } else if (lastWord.match(/(s|x|z|ch|sh)es$/i)) {
    words.push(lastWord.replace(/es$/, "")); // buses → bus
  } else if (lastWord.match(/s$/i) && !lastWord.match(/ss$/i)) {
    words.push(lastWord.replace(/s$/, "")); // cats → cat
  } else {
    words.push(lastWord);
  }

  return words.join(" ");
};

export const makePlural = (word) => {
  const irregularPlurals = {
    child: "children",
    person: "people",
    mouse: "mice",
    tooth: "teeth",
    foot: "feet",
    goose: "geese",
    man: "men",
    woman: "women",
  };

  let words = word.split(" "); // Handle multi-word phrases
  let lastWord = words.pop(); // Get last word

  if (irregularPlurals[lastWord.toLowerCase()]) {
    words.push(irregularPlurals[lastWord.toLowerCase()]);
  } else if (lastWord.match(/[^aeiou]y$/i)) {
    words.push(lastWord.replace(/y$/, "ies")); // activity → activities
  } else if (lastWord.match(/(s|x|z|ch|sh)$/i)) {
    words.push(lastWord + "es"); // bus → buses, box → boxes
  } else if (!lastWord.match(/s$/i)) {
    words.push(lastWord + "s"); // car → cars
  } else {
    words.push(lastWord); // Already plural
  }

  return words.join(" ");
};

export const guestCombinationSentence = (guestCombinationArray) => {
  const guestCount = guestCombinationCountFuc(guestCombinationArray);
  return `${guestCount.adult} ${pluralize("Adult", guestCount.adult)}, ${
    guestCount.child
  } ${pluralize("child", guestCount.child)}`;
};

export const packageForMyBookingFunc = (childData) => {
  if (!Array.isArray(childData) || childData.length === 0) {
    return { is_package: false, package_name: "" };
  }

  const packageItem = childData.find((x) => x?.package_id);

  return {
    is_package: !!packageItem,
    package_name: packageItem?.package_name || "",
    package_booking_id: packageItem?.package_booking_id || null,
    agent_booking_id: packageItem?.agent_booking_id || null,
  };
};

export const countCartWithPackage = (cartArray) => {
  if (Array.isArray(cartArray) && cartArray.length) {
    const withPackageCount = cartArray.some((x) =>
      x.hasOwnProperty("package_id")
    )
      ? 1
      : 0;
    const withOutPackageCount = cartArray.filter(
      (x) => !x.hasOwnProperty("package_id")
    ).length;
    return withPackageCount + withOutPackageCount;
  } else {
    return 0;
  }
};
